import React,{Component} from 'react';
import './BarContext.css'
import 'typeface-roboto'
import LoginForm from './LoginForm'
import Grow from 'material-ui/transitions/Grow';
import Divider from 'material-ui/Divider';


class  ChangeButton extends Component{

    render(){
        return(
            <a>
                <i className="material-icons" style={{color:'#5ac73e',fontSize:50,display:'block',margin:'10px',position:'absolute',bottom:'20px',right:'5px'}}
                   onClick={this.props.changeContext}>
                    perm_data_setting</i></a>
        )
    }
}




class BarContext extends Component{

    constructor(prpos){
        super(prpos);

        this.state={
            menuOpen:false,
            changToggle:true
        }
    }


    changeState (event){
        this.setState(
            {
                changeToggle:!this.state.changeToggle
            }

        )
    }

    render(){
        const barStyle={
            display:'flex',
            flexDirection:'column',
            flexWrap:'warp',
            justifyContent:'flex',
            height:'100%'
        }
        console.log(this.state)
        var context=null;
        if (!this.state.changeToggle){
            context=(<div>
                   <Grow in={!this.state.changeToggle}>
                <div  style={{textAlign:'center',marginTop:'50px',marginBottom:'10px'}}>
                    <img src='image/profilePic.jpg'style={{borderRadius:'50%'}}  width='120px' alt=''/>
                </div>
                   </Grow>

                <Grow in={!this.state.changeToggle}>
                <div  style={{textAlign:'center',marginTop:'10px',marginBottom:'10px'}}>
        <span  style={{color:'white'}}>Kayer</span>
        </div>
                </Grow>

                <Grow in={!this.state.changeToggle}>
            <div  style={{textAlign:'center',marginTop:'10px',marginBottom:'10px',marginLeft:'50px',marginRight:'50px',}}>
                <span style={{color:'white'}}>Why is a raven like a writing desk?</span>
                </div>
                </Grow>
                <Divider/>
                <Grow in={!this.state.changeToggle}>
                <div style={{textAlign:'center',marginTop:'10px',marginBottom:'10px'}}>
                    <table valign="bottom" style={{display:'inline',marginTop:'10px',marginBottom:'10px'}}>
                        <tbody>
                        <tr>
                            <td className={'blok'} onClick={this.props.handleNovelRoute}>

                                <i className="material-icons" style={{color:'#16c2d1',fontSize:35,display:'block',margin:'10px'}} >
                                    library_books</i>
                                <span style={{color:'#16c2d1',fontSize:'10px',display:'block',margin:'20px 8px 20px'}}>NOVEL</span>

                            </td>

                            <td className={'blok'} onClick={this.props.handleBlogRoute}>

                                <i className="material-icons" style={{color:'#5ac73e',fontSize:35,display:'block',margin:'10px'}} >
                                    textsms</i>
                                <span style={{color:'#5ac73e',fontSize:'10px',display:'block',margin:'20px 13px 20px'}}>BLOG</span>

                            </td>


                            <td className={'blok'} style={{textDecoration:'none'}} onClick={this.props.handleProjectRoute}>

                                <i className="material-icons" style={{color:'#d11bc9',fontSize:35,display:'block',margin:'10px'}} >
                                    settings</i>
                                <span style={{color:'#d11bc9',fontSize:'10px',display:'block',margin:'20px 4px 20px'}}>PROJECT</span>

                            </td>

                            <td className={'blok'} onClick={this.props.handleAboutRoute}>

                                <i className="material-icons" style={{color:'#ffa203',fontSize:35,display:'block',margin:'10px'}} >
                                    accessibility</i>
                                <span style={{color:'#ffa203',fontSize:'10px',display:'block',margin:'20px 10px 20px'}}>ABOUT</span>

                            </td>

                        </tr>
                        </tbody>
                    </table>
                </div>
                </Grow>
                    <Divider/>
                </div>

            )

        }else {
            context=<LoginForm handleLogin={this.props.handleLogin}
                               writeBlog={this.props.writeBlog}
                               writeNovel={this.props.writeNovel}
                               writeNovelChapter={this.props.writeNovelChapter}
                               writeProject={this.props.writeProject}
                               handleStartRoute={this.props.handleStartRoute}
            />
        }

        return                 (
                <div style={barStyle}>
                    {context}
                    <ChangeButton changeContext={this.changeState.bind(this)}/>
                </div>
                );
    };
}
export default BarContext;


// WEBPACK FOOTER //
// ./src/Compent/SliderBar/BarContext.js